import React, { useState, useContext } from "react";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import { useStyles } from "components/layout/CommonStyles";
import Input from "components/inputs/Input";
import InventoryContext from "context/inventory/inventoryContext";
import { Redirect } from "react-router-dom";
import { dateToBR } from "utils/dates/DateToBRr";
import SmallSpinner from "components/layout/spinners/SmallSpinner";
import Button from "@material-ui/core/Button";
const redirect = go => {
  if (go) return <Redirect to={`/CollaboratorsRequests`} />;
};

const DialogReqApprove = props => {
  var FormatDateToDataBase =
    require("../../../utils/dates/FormatDateToDataBase").FormatDateToDataBase;
  const [t] = useTranslation();
  const classes = useStyles();
  const {
    open,
    setOpen,
    typeName,
    requisitionId,
    approverId,
    dateRequisition,
    context,
    type,
    itemsToBeMoved,
    itemsToBeReturn,
    softwaresRequisitions,
    requisition,
    executeName,
  } = props;

  const inventoryContext = useContext(InventoryContext);
  const [values, setValues] = useState({
    observation: "",
    justification: "",
  });
  const [requiredFieldJustification, setRequiredFieldJustification] =
    useState(false);
  const [mustRedirect, setMustRedirect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { AdmExecutedRequisitions } = inventoryContext;

  const clear = () => {
    setValues({
      ...values,
      observation: "",
      justification: "",
    });
  };

  const handleClose = () => {
    setOpen(false);
    setRequiredFieldJustification(false);
    clear();
  };

  function handleClick() {
    if (!values.justification && context === "refuse") {
      setRequiredFieldJustification(true);
      return;
    }
    setIsLoading(true);

    //allows button styling before calling the submit function
    setTimeout(() => {
      handleSubmit();
    }, 1000);
  }

  const handleSubmit = () => {
    const isApprove = context === "approve";
    const motivationText = isApprove
      ? values.observation
      : values.justification;

    const formData = new FormData();
    formData.append("executorId", approverId);
    formData.append("dateCreated", FormatDateToDataBase(new Date()));
    formData.append("executorResponse", motivationText);
    formData.append("executed", isApprove);

    const emailDatasManager = [
      {
        user: [
          {
            name: requisition.approver,
            email: requisition.approverEmail,
            url: `${process.env.REACT_APP_FRONT}Requisition/${requisition.id}`,
          },
        ],
        type: typeName,
        date: new Date(),
        name: requisition.requesterShortName,
        patrimonyName: executeName,
        approve: isApprove,
        motivationBool: motivationText.length > 0,
        motivationData: motivationText,
        motivationName: isApprove ? "Observação" : "Motivo",
        itens: [],
      },
    ];

    let itens = [];

    switch (type) {
      case "use_of_equipment": {
        const equipmentList = requisition?.itemEquipmentRequisition || [];
        itens = equipmentList.map(item => [
          item.itemName,
          item.ufcCode || item.lsbdCode || item.fcpcCode || item.externCode,
          item.serialNumber,
          item.place,
        ]);

        (itemsToBeReturn || []).forEach((item, i) => {
          formData.append(`itemsToBeUsed[${i}].id`, item.id);
          formData.append(`itemsToBeUsed[${i}].change`, item.change || false);
          formData.append(`itemsToBeUsed[${i}].itemId`, item.itemId || "");
          formData.append(
            `itemsToBeUsed[${i}].newPlaceId`,
            item.newPlaceId || "",
          );
          formData.append(
            `itemsToBeUsed[${i}].newResponsibleId`,
            item.newResponsibleId || "",
          );
          formData.append(
            `itemsToBeUsed[${i}].newStatusId`,
            item.newStatusId || "",
          );
        });
        break;
      }
      case "use_of_software": {
        const softwareList = softwaresRequisitions || [];
        itens = softwareList.map(item => [
          item.software,
          item.keyOrEmail,
          item.machine,
        ]);
        (softwaresRequisitions || []).forEach((sw, i) => {
          formData.append(`softwareToBeUsed[${i}].id`, sw.id);
          formData.append(`softwareToBeUsed[${i}].change`, sw.change || false);
          formData.append(
            `softwareToBeUsed[${i}].itemId`,
            sw.newMachineId || "",
          );
          formData.append(
            `softwareToBeUsed[${i}].licenseId`,
            sw.licenseId || "",
          );
          formData.append(
            `softwareToBeUsed[${i}].newMachineId`,
            sw.newMachineId || "",
          );
          formData.append(
            `softwareToBeUsed[${i}].newResponsibleId`,
            sw.newResponsibleId || "",
          );
          formData.append(`softwareToBeUsed[${i}].newStatus`, sw.status || "");
        });
        break;
      }
      case "return_of_software": {
        const softwareList = softwaresRequisitions || [];
        itens = softwareList.map(item => [item.software, item.keyOrEmail]);
        (softwaresRequisitions || []).forEach((sw, i) => {
          formData.append(`softwareToBeReturn[${i}].id`, sw.id);
          formData.append(
            `softwareToBeReturn[${i}].change`,
            sw.change || false,
          );
          formData.append(
            `softwareToBeReturn[${i}].itemId`,
            sw.newMachineId || "",
          );
          formData.append(`softwareToBeReturn[${i}].licenseId`, sw.licenseId);
          formData.append(
            `softwareToBeReturn[${i}].newMachineId`,
            sw.newMachineId || "",
          );
          formData.append(
            `softwareToBeReturn[${i}].newResponsibleId`,
            sw.newResponsibleId || "",
          );
          formData.append(
            `softwareToBeReturn[${i}].newExternalResponsibleId`,
            sw.newExternalResponsibleId || "",
          );
          formData.append(
            `softwareToBeReturn[${i}].newStatus`,
            sw.newStatus === "Disponível" ? "AVAILABLE" : "UNAVAILABLE",
          );
        });
        break;
      }

      case "return_of_equipment": {
        itens = (itemsToBeReturn || []).map(item => [
          item.name,
          item.ufcCode || item.lsbdCode || item.fcpcCode || item.externCode,
          item.serialNumber,
        ]);

        (itemsToBeReturn || []).forEach((item, i) => {
          formData.append(`itemsToBeReturn[${i}].id`, item.id);
          formData.append(`itemsToBeReturn[${i}].change`, item.change || false);
          formData.append(
            `itemsToBeReturn[${i}].itemId`,
            item.itemId === 0 ? null : item.itemId,
          );
          formData.append(
            `itemsToBeReturn[${i}].newPlaceId`,
            item.newPlaceId || "",
          );
          formData.append(
            `itemsToBeReturn[${i}].newResponsibleId`,
            item.newResponsibleId || "",
          );
          formData.append(
            `itemsToBeReturn[${i}].newExternalResponsibleId`,
            item.newExternalResponsibleId || "",
          );
          formData.append(
            `itemsToBeReturn[${i}].newStatusId`,
            item.newStatusId || "",
          );
        });
        break;
      }

      case "change_of_local": {
        itens = (itemsToBeMoved || []).map(item => [
          item.name,
          item.ufcCode || item.lsbdCode || item.fcpcCode || item.externCode,
          item.serialNumber,
          item.oldPlace,
          item.newPlace,
        ]);

        (itemsToBeMoved || []).forEach((item, i) => {
          formData.append(`itemsToBeMoved[${i}].id`, item.id);
          formData.append(`itemsToBeMoved[${i}].itemId`, item.itemId);
          formData.append(`itemsToBeMoved[${i}].newPlaceId`, item.newPlaceId);
        });
        break;
      }

      default:
        break;
    }

    const emailDatasCollaborator = [
      {
        user: [
          {
            name: requisition.requester,
            email: requisition.requesterEmail,
            url: `${process.env.REACT_APP_FRONT}Requisition/${requisition.id}`,
          },
        ],
        type: typeName,
        date: new Date(),
        name: requisition.requesterShortName,
        patrimonyName: executeName,
        approve: isApprove,
        motivationBool: motivationText.length > 0,
        motivationData: motivationText,
        motivationName: isApprove ? "Observação" : "Motivo",
        itens,
      },
    ];

    AdmExecutedRequisitions(
      requisitionId,
      formData,
      emailDatasManager,
      emailDatasCollaborator,
      "/RequisitionsAdm",
    );
    setOpen(false);
    clear();
  };

  const handleChange = (name, value) => {
    setRequiredFieldJustification(false);
    setValues({ ...values, [name]: value });
  };

  return (
    <React.Fragment>
      {redirect(mustRedirect)}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        aria-labelledby="form-dialog-title"
        msg="mensagem"
      >
        <DialogTitle className={classes.actionsTitle}>
          <span style={{ fontWeight: "bold" }}>
            {context === "approve"
              ? t("INVENTORY.executeRequisition")
              : t("INVENTORY.refuseRequisition")}
          </span>
          <IconButton
            style={{ float: "right", marginTop: -10, marginRight: -17 }}
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container>
              {context === "approve"
                ? t("INVENTORY.executeRequisitionMessage")
                : t("INVENTORY.refuseRequisitionMessage")}
            </Grid>
            <Grid container style={{ paddingTop: "20px" }}>
              <Grid item xs={12} sm={4}>
                <b>{t("GENERAL.date").toUpperCase()}</b>
              </Grid>
              <Grid item xs={12} sm={4}>
                <b>{t("INVENTORY.requestType").toUpperCase()}</b>
              </Grid>
            </Grid>
            <Grid container style={{ paddingBottom: "10px" }}>
              <Grid item xs={12} sm={4}>
                {dateToBR(new Date(dateRequisition))}
              </Grid>
              <Grid item xs={12} sm={6}>
                {typeName}
              </Grid>
            </Grid>
            <Input
              error={requiredFieldJustification}
              multiline
              fullWidth
              variant="outlined"
              rows="4"
              value={
                context === "approve"
                  ? values.observation
                  : values.justification
              }
              valueName={
                context === "approve" ? "observation" : "justification"
              }
              label={
                context === "approve"
                  ? t("INVENTORY.observation")
                  : t("INVENTORY.justification") + "*"
              }
              margin="normal"
              maxLength={200}
              helperText={
                requiredFieldJustification
                  ? t("GENERAL.requiredField")
                  : context === "approve"
                    ? `${
                        values.observation.length > 0
                          ? values.observation.length
                          : 0
                      }/200`
                    : `${
                        values.justification.length > 0
                          ? values.justification.length
                          : 0
                      }/200`
              }
              handleChange={handleChange}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            style={{
              padding: "14px 24px",
              fontWeight: "normal",
              fontSize: "14px",
            }}
            onClick={handleClose}
            disabled={isLoading}
          >
            {t("GENERAL.cancel").toLocaleUpperCase()}
          </Button>

          <Button
            color="primary"
            variant="contained"
            className={classes.blueButton}
            onClick={handleClick}
            disabled={isLoading}
          >
            {context === "approve"
              ? t("GENERAL.execute").toLocaleUpperCase()
              : t("GENERAL.refuse").toLocaleUpperCase()}
            {isLoading && (
              <div>
                <SmallSpinner />
              </div>
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default DialogReqApprove;
